export const LOADING = 'LOADING'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'

export const RESET_ERROR = 'RESET_ERROR'